import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import PropTypes from "prop-types";
import { FormattedDate } from "react-intl";
import { FormattedNumber } from "../../../FormattedNumber/FormattedNumber"
import { CustomFormInput } from "../../../../utils/FormFields";
import Accounts from "./Accounts";

const CorpEvent = ({ corpEvent }) => (
  <div>
    <Row>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Date">
          <FormattedDate value={`${corpEvent.Date}T00:00`} />
        </CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Type">{corpEvent.CorporateEventType}</CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Asset">{corpEvent.AssetName}</CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Asset Currency">{corpEvent.CurrencyISO}</CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Settlement Currency">
          {corpEvent.CorporateEventSettlementCurrencyISO}
        </CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Settlement FX">
          <FormattedNumber
            value={corpEvent.CorporateEventFX}
            dataTypeDecimalName="currency"
          />
        </CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Commission Currency">
          {corpEvent.CorporateEventCommissionCurrencyISO}
        </CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Commission FX">
          <FormattedNumber
            value={corpEvent.CorporateEventCommissionFX}
            dataTypeDecimalName="currency"
          />
        </CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Tax Currency">{corpEvent.CorporateEventTaxCurrencyISO}</CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Tax FX">
          <FormattedNumber
            value={corpEvent.CorporateEventTaxFX}
            dataTypeDecimalName="currency"
          />
        </CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Client Tax FX">
          <FormattedNumber
            value={corpEvent.CorporateEventClientTaxFX}
            dataTypeDecimalName="currency"
          />
        </CustomFormInput>
      </Col>
    </Row>
    <Accounts accounts={corpEvent.Account || []} />
  </div>
);

export default CorpEvent;
